import { createContext } from 'react';

import { InvalidSectionsItem } from '@features/campaigns/shared/types/campaign.ts';
import { CampaignId } from '@shared/types/campaign';

export interface BuilderCampaignData {
  campaignId: CampaignId | undefined;
  invalidSections?: InvalidSectionsItem[];
}

interface BuilderCampaignDataContextValue {
  campaignData: BuilderCampaignData;
  setCampaignData: (data: BuilderCampaignData) => void;
}

export const BuilderCampaignDataContext = createContext<BuilderCampaignDataContextValue | undefined>(undefined);
